import Hugo from "./Hugo"

export default Hugo

export {
    default as useHugoState
} from './useHugoState'

export {
    default as soundboard
} from './soundboard'

export {
    default as expressions
} from './expressions'

export {
    useCryptWriter,
    useTypeWriter,
    useScroll,
    useCLI,
    useLinebreak,
    useScrollable,
    useButton,
    LinebreakStrategy,
} from './gpu'

export type {
    HugoState,
    HugoStateApi,
    HugoStateOptions,
    HugoStateOutput,
    HugoStateOutputOptions,
    UseHugoState,
} from './types'

export {
    HugoEventType,
} from './types'

export {
    useTemplateEngine,
} from './templateEngine'